if (!customElements.get('product-icon-mega-menu')) {
  class ProductIconMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.closeTimeout = null;
      this.handlePointerEnter = this.handlePointerEnter.bind(this);
      this.handlePointerLeave = this.handlePointerLeave.bind(this);
      this.handleFocusIn = this.handleFocusIn.bind(this);
      this.handleFocusOut = this.handleFocusOut.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.handleMenuOpen = this.handleMenuOpen.bind(this);
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-product-icon-menu-trigger]');
      this.panel = this.querySelector('[data-product-icon-menu-panel]');
      this.header = this.closest('.header');
      this.headerWrapper = this.closest('.header-wrapper');

      if (!this.trigger || !this.panel) return;

      this.addEventListener('pointerenter', this.handlePointerEnter);
      this.addEventListener('pointerleave', this.handlePointerLeave);
      this.addEventListener('focusin', this.handleFocusIn);
      this.addEventListener('focusout', this.handleFocusOut);
      this.addEventListener('keydown', this.handleKeyDown);
      document.addEventListener('product-icon-menu:open', this.handleMenuOpen);
    }

    disconnectedCallback() {
      window.clearTimeout(this.closeTimeout);
      this.removeEventListener('pointerenter', this.handlePointerEnter);
      this.removeEventListener('pointerleave', this.handlePointerLeave);
      this.removeEventListener('focusin', this.handleFocusIn);
      this.removeEventListener('focusout', this.handleFocusOut);
      this.removeEventListener('keydown', this.handleKeyDown);
      document.removeEventListener('product-icon-menu:open', this.handleMenuOpen);
    }

    handlePointerEnter() {
      window.clearTimeout(this.closeTimeout);
      this.open();
    }

    handlePointerLeave() {
      this.queueClose();
    }

    handleFocusIn() {
      window.clearTimeout(this.closeTimeout);
      this.open();
    }

    handleFocusOut() {
      window.setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      }, 0);
    }

    handleKeyDown(event) {
      if (event.key !== 'Escape' || !this.classList.contains('is-open')) return;

      event.preventDefault();
      this.close();
      this.trigger.focus();
    }

    handleMenuOpen(event) {
      if (event.detail.menu !== this) this.close();
    }

    queueClose() {
      window.clearTimeout(this.closeTimeout);
      this.closeTimeout = window.setTimeout(() => this.close(), 140);
    }

    open() {
      if (this.classList.contains('is-open')) return;

      document.dispatchEvent(new CustomEvent('product-icon-menu:open', { detail: { menu: this } }));
      document.querySelectorAll('header-menu').forEach((menu) => menu.close?.());
      this.classList.add('is-open');
      this.trigger.setAttribute('aria-expanded', 'true');
      this.panel.inert = false;
      this.header?.classList.add('open');
      this.headerWrapper?.classList.add('open');
    }

    close() {
      if (!this.classList.contains('is-open')) return;

      this.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.panel.inert = true;
      this.header?.classList.remove('open');
      this.headerWrapper?.classList.remove('open');
    }
  }

  customElements.define('product-icon-mega-menu', ProductIconMegaMenu);
}
